import React from 'react'
import { TABLA_HISTOGRAMA_CALADO_POR_PUESTO } from '../../../../config/tables'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'

function HistogramaCaladoPorPuestoView () {
  return (
    <MuiTable id={TABLA_HISTOGRAMA_CALADO_POR_PUESTO} />

  )
}
export default HistogramaCaladoPorPuestoView
